import React from 'react';
import { Paper, Typography, Box, CircularProgress } from '@mui/material';
import ReactMarkdown from 'react-markdown';
import { qaItemStyles } from '../../styles/qaStyles';
import { markdownComponents } from '../../utils';

/**
 * 개별 QA 히스토리 아이템 컴포넌트
 * @param {object} props - 컴포넌트 props
 * @param {object} props.qa - QA 데이터
 * @param {number} props.index - 인덱스
 * @param {React.RefObject} props.answerRef - 답변 ref
 * @returns {JSX.Element} - QA 히스토리 아이템
 */
const QAHistoryItem = ({ qa, index, answerRef }) => {
  return (
    <Paper
      key={index}
      ref={answerRef}
      elevation={0}
      sx={qaItemStyles.container}
    >
      <Typography variant="body2" sx={qaItemStyles.question}>
        Q. {qa.question}
      </Typography>
      {qa.answer === null ? (
        <Box sx={qaItemStyles.loadingContainer}>
          <CircularProgress size={22} color="primary" />
        </Box>
      ) : (
        <Box sx={qaItemStyles.answerContainer}>
          <ReactMarkdown
            children={qa.answer}
            components={markdownComponents}
          />
        </Box>
      )}
    </Paper>
  );
};

export default QAHistoryItem; 